 document.addEventListener('click', function(event) {
      const link = event.target.closest('.line-item .cart-items__remove');
      if (!link) return;
      event.preventDefault();
      event.stopPropagation();
      const removeUrl = link.getAttribute('href');

      fetch(removeUrl, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(data => {
        document.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );
        console.log('Item removed and cart refreshed.');
      })
      .catch(error => console.error('Error removing item:', error));
    });

    function openPopup(event) {
      const popup = event.target.closest('.installation-title');
      if (!popup) return;
      document.querySelector(".popup-overlay").classList.add('active');
    }

    function closePopup(event) {
      const popup = event.target.closest('.popup-close');
      if (!popup) return;
      document.querySelector(".popup-overlay").classList.remove('active');
    }

    document.addEventListener('click', openPopup);
    document.addEventListener('touchstart', openPopup);

    document.addEventListener('click', closePopup);
    document.addEventListener('touchstart', closePopup);


     let userSelectedSize = false;

  document.addEventListener('DOMContentLoaded', function () {
    const atcButton = document.querySelector('.shopify-product-form button[type="submit"]');
    if (atcButton) {
      atcButton.setAttribute('disabled', '');
    }

    document.querySelectorAll('[id$="-selected-value"]').forEach(el => {
      el.textContent = 'Select a size';
    });

    document.querySelectorAll('[data-option-position]').forEach(el => {
      el.addEventListener('click', function () {
        userSelectedSize = true;
      });
    });
  });

  document.addEventListener('variant:change', function (event) {
    if (!userSelectedSize) return;

    if (!event.detail || !event.detail.variant) return;

    const variant = event.detail.variant;
    const sizeIndex = 1; // assuming Size is the first option

    const selectedSize = variant.options[sizeIndex];

    document.querySelectorAll('[id$="-selected-value"]').forEach(el => {
      el.textContent = selectedSize;
    });

    const atcButton = document.querySelector('.shopify-product-form button[type="submit"]');
    if (atcButton) {
      atcButton.removeAttribute('disabled');
    }
  });


document.addEventListener("DOMContentLoaded", function () {

  const headings = document.querySelectorAll(".tab-heading");
  const contents = document.querySelectorAll(".tab-content");

  // Show first tab by default
  if (headings.length > 0 && contents.length > 0) {
    headings[0].classList.add("active");
    contents[0].style.display = "block";
  }

  headings.forEach((heading, index) => {
    heading.addEventListener("click", () => {

      // remove active from all
      headings.forEach(h => h.classList.remove("active"));
      contents.forEach(c => c.style.display = "none");

      // add active to clicked
      heading.classList.add("active");
      contents[index].style.display = "block";

    });
  });

});

var swiper = new Swiper(".mySwiper", {
      loop: true,
      slidesPerView: 2,
      spaceBetween: 10,
      // centeredSlides: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        576: {
          slidesPerView: 2
        },
        768: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 2
        }
      }
  });